
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Touristbusrentalsservice() {



    const cardData =
    {
        keyword: 'Tourist Bus Rental Services',
        heading: 'Amruta Travels: Tourist Bus Rental Services',
        headingDescription: 'Amruta Travels offers Tourist Bus Rental Services, providing reliable and comfortable transportation solutions for all your travel needs. Whether you are planning a sightseeing tour, family vacation, corporate outing, or group excursion, our well-maintained buses ensure a smooth and enjoyable journey. Choose from our range of buses, including 17-seater, 32-seater, and 50-seater options, to suit your group size. With experienced drivers, punctual service, affordable pricing, and 24/7 availability, Amruta Travels makes your tourist travel simple and stress-free. Book your tourist bus with Amruta Travels and embark on a journey of comfort and discovery!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732, Shaniwar Wada served as the seat of the Peshwas of the Maratha Empire. This grand fortification, though partially destroyed by fire in 1828, still showcases its majestic gates, sturdy walls, and intricate architecture. The Delhi Darwaza, its main gate, is particularly notable. The site is steeped in history and legends, including tales of royal intrigue and the ghost of a young prince. An evening light and sound show narrates its rich past, making it a must-visit for history enthusiasts."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892 by Sultan Aga Khan III, the palace is a significant landmark in India's freedom movement. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and his secretary Mahadev Desai during the Quit India Movement in 1942. The palace now houses a museum with photographs and personal artifacts of Gandhi, and the samadhis (memorials) of Kasturba Gandhi and Mahadev Desai. The serene gardens and Italian arches add to its architectural beauty."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the Sahyadri Hills, Sinhagad Fort is approximately 35 km from Pune. Known for the historic Battle of Sinhagad in 1670, where Maratha warrior Tanaji Malusare fought valiantly, the fort offers panoramic views of the surrounding region. It's a popular trekking destination, especially during monsoons, and visitors often enjoy local delicacies like pithla-bhakri at the summit."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, this tranquil retreat is one of the world's largest meditation centers. Founded by spiritual leader Osho, the resort offers a blend of traditional and contemporary meditation techniques, wellness programs, and therapies. The lush gardens, serene ambiance, and international community make it a haven for those seeking inner peace and rejuvenation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple is dedicated to Lord Shiva. Carved from a single basalt rock, it features a circular Nandi mandapa and intricately designed pillars. Despite being amidst the bustling city, the temple offers a peaceful retreat and stands as a testament to ancient Indian rock-cut architecture."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum houses over 20,000 artifacts collected by Dr. Dinkar G. Kelkar in memory of his son. The collection includes musical instruments, paintings, sculptures, and everyday objects from the 18th and 19th centuries, offering a glimpse into India's rich cultural heritage. The museum's architecture, resembling a traditional Rajasthani mansion, adds to its charm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Situated on the Mutha River, Khadakwasla Dam is a popular spot for picnics and evening outings. The dam's vicinity offers scenic views, especially during monsoons when the reservoir is full. The area is also known for local street food vendors serving snacks like corn on the cob and bhel puri."
  },
  {
    "title": "Fergusson College Road",
    "description": "A bustling street in Pune, Fergusson College Road is lined with cafes, bookstores, boutiques, and eateries. It's a favorite hangout spot for students and youngsters, offering a vibrant mix of shopping and culinary experiences. The street comes alive in the evenings, reflecting the city's youthful energy."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is associated with the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and paintings depicting significant events from Shivaji's life. Its red-colored walls and historical significance make it a notable landmark in Pune."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by the Korakuen Garden in Okayama, Japan, this beautifully landscaped garden spans over 10 acres. It features manicured lawns, flowing streams, bridges, and a variety of flora. The garden offers a serene environment, ideal for leisurely walks and photography."
  }
],



     "services": [
    {
      "name": "Tour Bus Rental in Pune",
      "description": "Amruta Travels offers reliable and affordable tour bus rental services in Pune for local sightseeing, outstation trips, corporate tours, and more. Our fleet includes AC and Non-AC buses of various seating capacities, perfect for small and large groups seeking comfortable and convenient travel."
    },
    {
      "name": "Tour Bus Rental Cost in Pune",
      "description": "Looking for transparent and budget-friendly tour bus rental costs in Pune? Amruta Travels provides competitive pricing based on duration, distance, and bus type. Whether it's a one-day local tour or a long-distance multi-day trip, we offer customized quotes for every travel plan."
    },
    {
      "name": "Tourist Bus Rental Services in Bibwewadi",
      "description": "Planning a trip from Bibwewadi, Pune? Amruta Travels offers dependable tourist bus rental services in Bibwewadi with a variety of bus types including luxury, semi-luxury, and sleeper coaches. Ideal for school trips, pilgrimages, and family outings."
    },
    {
      "name": "Tourist Bus Rental Services in Hadapsar",
      "description": "Hire a tourist bus from Hadapsar, Pune with Amruta Travels for comfortable and hassle-free travel. Our buses come equipped with push-back seats, AC, entertainment systems, and experienced drivers to make your journey safe and enjoyable."
    },
    {
      "name": "Tourist Bus Rental Services in Hinjewadi",
      "description": "Amruta Travels provides premium tourist bus rentals in Hinjewadi, Pune – perfect for IT park employee transport, corporate team outings, or family vacations. Choose from 20 to 50 seater buses for stress-free and spacious travel."
    },
    {
      "name": "Tour Bus Rental Near Me Pune",
      "description": "Searching for a tour bus rental near you in Pune? Amruta Travels has multiple pickup points across the city including Kothrud, Viman Nagar, Kharadi, and more, making it easy to rent a tour bus close to your location."
    },
    {
      "name": "Tour Bus Hire in Pune",
      "description": "Tour Pune or beyond in comfort with Amruta Travels' bus hire services. From heritage sites to hill stations, we offer personalized itineraries with well-maintained buses and courteous staff to ensure a memorable trip."
    },
    {
      "name": "Private Tour Bus Rental in Shivaji Nagar",
      "description": "Hire a private tour bus from Shivaji Nagar, Pune with Amruta Travels. Perfect for exclusive family tours, friends’ getaways, or VIP delegations, our buses offer privacy, luxury, and professional service for a high-quality travel experience."
    },
    {
      "name": "Tour Bus Rental Price",
      "description": "Amruta Travels offers competitive tour bus rental pricing tailored to your route, duration, and group size. Whether you need a 20-seater mini bus or a 50-seater full coach, we provide cost-effective packages with no hidden fees."
    },
    {
      "name": "Mini Tour Bus Rental",
      "description": "Rent a mini tour bus with Amruta Travels for short trips, weekend getaways, or city sightseeing. Ideal for small groups of 14 to 25 passengers, our mini buses are comfortable, clean, and come with all essential travel amenities."
    },
    {
      "name": "Hire a Bus for Tour in Pune",
      "description": "Plan your group tour from Pune with Amruta Travels. We offer a wide range of buses for hire with flexible packages for local, intercity, or outstation tours. Perfect for group excursions, weddings, religious trips, or corporate retreats."
    },
    {
      "name": "Luxury Tour Bus Companies",
      "description": "Amruta Travels is among the top luxury tour bus companies in Pune offering high-end buses with modern interiors, reclining seats, AC, and entertainment systems. Travel in elegance and comfort with premium service tailored to your group."
    },
    {
      "name": "Luxury Tour Bus Rentals Service",
      "description": "Our luxury bus rentals are perfect for those looking to travel in style. Whether it’s for a wedding, VIP event, or executive outing, Amruta Travels’ luxury coaches ensure top-notch comfort, punctuality, and personalized service."
    },
    {
      "name": "Sleeper Tour Bus Hire Pune",
      "description": "For long-distance journeys from Pune, book our sleeper tour buses equipped with comfortable berths, privacy curtains, charging points, and air conditioning. Ideal for overnight travel, ensuring restful trips for your group."
    }
  ],
  "tableData": [
    ["Tour Bus Rental in Pune", "Tour Bus Rental Cost in Pune"],
    ["Tourist Bus Rental Services in Bibwewadi", "Tourist Bus Rental Services in Hadapsar"],
    ["Tourist Bus Rental Services in Hinjewadi", "Tour Bus Rental Near me Pune"],
    ["Tour Bus Hire in Pune", "Private tour bus rental in Shivaji Nagar"],
    ["Tour Bus Rental price", "Mini Tour bus rental"],
    ["Hire a Bus for tour in pune", "Luxury Tour Bus Companies"],
    ["Luxury Tour Bus Rentals Service", "Sleeper Tour Bus Hire Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comprehensive Tourist Bus Rental Services for All Travel Needs",
    "WhyChoosedescription": "Amruta Travels offers professional and affordable Tourist Bus Rental Services across Pune and beyond, ideal for sightseeing tours, weekend getaways, spiritual pilgrimages, adventure trips, and customized group tours. Whether you're planning a one-day excursion or a multi-day interstate tour, we provide a smooth, organized travel experience with comfort, safety, and convenience as our top priorities."
  },
  {
    "WhyChooseheading": "Fleet Options for Every Group Size and Preference",
    "WhyChoosedescription": "Choose from a diverse range of buses including 17, 20, 32, 35, 40, 45, and 50-seater tourist buses. All vehicles are equipped with spacious seating, air-conditioning, ample legroom, overhead storage, and large windows for scenic views. Whether it’s a small group of friends or a large tour party, we have the right bus to meet your travel expectations."
  },
  {
    "WhyChooseheading": "Ideal for Local Sightseeing and Long-Distance Tours",
    "WhyChoosedescription": "Our Tourist Bus Rental Services are perfect for visiting popular destinations such as Lonavala, Mahabaleshwar, Shirdi, Lavasa, Goa, Konkan, Rajasthan, and the 12 Jyotirlingas. We also cover historical sites, hill stations, religious circuits, and customized travel routes as per your itinerary. Each trip is tailored to ensure a fulfilling travel experience packed with sightseeing and comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers and Tour-Friendly Staff",
    "WhyChoosedescription": "Our trained drivers are skilled in both city and highway travel and are familiar with the best tourist routes and stopovers. Courteous and punctual, they ensure your group reaches each destination safely and on time. For multi-day tours, we can also provide a tour coordinator or guide to assist with itinerary planning, temple timings, and sightseeing coordination."
  },
  {
    "WhyChooseheading": "Transparent Pricing with Budget and Premium Options",
    "WhyChoosedescription": "We offer competitive pricing tailored to suit both economy and premium travelers. Whether you're looking for a basic AC bus for a short trip or a luxury coach for an extensive tour, our pricing remains transparent with no hidden fees. We offer customizable packages that include fuel, tolls, driver charges, and optional services like hotel bookings and meals coordination."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Comfortable Buses",
    "WhyChoosedescription": "Each bus is regularly cleaned and sanitized, especially before and after every trip. Interiors are well-maintained, with reclining seats, clean upholstery, and properly working AC units. Our priority is to ensure hygiene, comfort, and a fatigue-free travel experience for all passengers, even on longer routes."
  },
  {
    "WhyChooseheading": "Customized Tour Planning Assistance",
    "WhyChoosedescription": "We help you plan your entire tour—right from route suggestions to stopovers, sightseeing slots, and hotel options. Whether it’s a temple tour, beach vacation, or hill station escape, we provide input on travel time, road conditions, and optimal routes so you can enjoy a seamless trip without any guesswork or delays."
  },
  {
    "WhyChooseheading": "Simple Booking Process and Reliable Support",
    "WhyChoosedescription": "With Amruta Travels, booking a tourist bus is quick and convenient. Use our online platform, connect with our booking team by phone, or visit our office. Our responsive customer support is available 24/7 to assist you with reservations, last-minute changes, and emergency assistance during your journey—ensuring peace of mind throughout your tour."
  }
]














    }

const faqData = [
  {
    question: 'What types of tourist buses are available for rent?',
    answer: 'We offer a wide variety of tourist buses including 32, 35, 40, 45, and 50-seater options. You can choose from AC, non-AC, deluxe, and luxury variants depending on your comfort and budget.',
  },
  {
    question: 'For what purposes can I rent a tourist bus?',
    answer: 'Our tourist buses are ideal for sightseeing tours, outstation trips, school and college tours, corporate events, religious yatras, weddings, and family functions. We cater to both short and long-distance travel needs.',
  },
  {
    question: 'How can I book a tourist bus rental service?',
    answer: 'Booking a tourist bus is simple. You can reach out to us via phone, fill out a booking form on our website, or visit our office. Our team will help you choose the right vehicle and plan your journey.',
  },
  {
    question: 'Are your tourist buses comfortable for long journeys?',
    answer: 'Yes, all our tourist buses are designed for long-distance comfort, equipped with push-back seats, air conditioning (optional), ample legroom, luggage storage, and onboard entertainment (in some models).',
  },
  {
    question: 'Do you provide tourist buses for intercity or interstate travel?',
    answer: 'Absolutely! We offer interstate tourist bus rentals for destinations like Goa, Shirdi, Lonavala, Mahabaleshwar, Mumbai, and across Maharashtra and India. Our services include experienced drivers and proper route planning.',
  },
  {
    question: 'Are meals and stays included in your tourist bus packages?',
    answer: 'We can arrange all-inclusive tour packages that include travel, meals, accommodation, and sightseeing. Or, you can opt only for bus rental if you prefer to manage the rest independently.',
  },
  {
    question: 'What safety measures are followed during the trip?',
    answer: 'We ensure all buses are regularly maintained, sanitized before each trip, and driven by licensed professionals. First-aid kits and GPS tracking are also available on select vehicles.',
  },
  {
    question: 'Can I rent a tourist bus for a customized itinerary?',
    answer: 'Yes, we offer fully customized tourist bus rental services. Share your itinerary, group size, and travel preferences, and we’ll plan a seamless experience tailored to your needs.',
  },
  {
    question: 'Why choose Amruta Travels for tourist bus rental services?',
    answer: 'Amruta Travels is known for reliable buses, professional drivers, on-time service, and excellent customer support. Whether it’s a short city tour or a multi-day interstate journey, we ensure your group travels comfortably and safely.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Anil Rane',
    role: 'Tour Organizer, Pune',
    text: 'We rented a 45-seater tourist bus for our group tour to Konkan. The bus was well-maintained, the driver was experienced, and the overall experience was smooth and enjoyable. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Kalpana Kulkarni',
    role: 'School Principal, Pune',
    text: 'Amruta Travels provided excellent tourist bus rental service for our annual school trip. The staff was very cooperative and safety standards were well maintained. Will surely book again.',
    rating: 5,
  },
];



























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tourist Bus Rental Services in Pune",
  "image": "https://bushireinpune.com/assets/images/tourist-bus-rental-services.jpg",
  "description": "Explore Pune and nearby destinations with our Tourist Bus Rental services. Whether you're planning a family tour, corporate outing, or group travel, we offer a wide range of tour buses including luxury buses, sleeper buses, and mini buses for hire at competitive prices. We serve areas like Bibwewadi, Hadapsar, Hinjewadi, and Shivaji Nagar in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "4200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/tourist-bus-rental-services"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Tourist Bus Rental Services in Pune | Hire Luxury, Sleeper & Mini Tour Buses</title>
  <meta 
    name="description" 
    content="Rent tourist buses in Pune for family tours, corporate outings, and group travel. Choose from luxury, sleeper, and mini tour buses with affordable pricing. Available in Bibwewadi, Hadapsar, Hinjewadi, and Shivaji Nagar." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/51.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Touristbusrentalsservice;